<template>
  <div
    class="map__container"
    :class="{ 'ecommerce-map': newDesign }"
  >
    <FindOdpPanel
      :city="selectedCity"
      @select="onCitySelect"
      :showLinkFindOffice="false"
      class="ecommerce-city-elect"
    />

    <div class="map-tabs">
      <div class="map-tab"
           :class="{' map-tab_active': receptionQuery}"
           id="branch-send"
           @click="() => {
              receptionQuery = true;
           }"
      >
        Пункты приема для интернет-магазинов
      </div>
      <div class="map-tab"
           :class="{' map-tab_active': !receptionQuery}"
           id="branch-reception"
           @click="() => {
              receptionQuery = false;
           }"
      >
        Пункты выдачи для клиентов
      </div>
    </div>
    <div class="map__content">
      <div class="map-legend" v-if="!newDesign && receptionQuery && (isTablet || isMobile)">
        <div class="map-legend__items">
          <div class="map-legend__item" v-if="legend.reception">
            <img :src="hrefIconBranch" class="map-legend__icon" />
            <p class="map-legend__text">Прием в отделении</p>
            <div class="map-legend__tooltip">
              <b-button id="button-question__branch"
                        class="icon-question d-none d-sm-inline-block"></b-button>
              <b-tooltip target="button-question__branch" placement="bottom" boundary-padding="0" custom-class="tooltip_legend tooltip_legend-receive-branch">
                Вне зависимости от&nbsp;времени передачи заказов отправление происходит на&nbsp;следующий день
              </b-tooltip>
            </div>
          </div>
          <div class="map-legend__item" v-if="legend.terminalReception">
            <img :src="hrefIconTerminal" class="map-legend__icon" />
            <p class="map-legend__text">Прием на терминале</p>
            <div class="map-legend__tooltip">
              <b-button id="button-question__terminal"
                        class="icon-question d-none d-sm-inline-block"></b-button>
              <b-tooltip target="button-question__terminal" placement="bottom" boundary-padding="0" custom-class="tooltip_legend tooltip_legend-terminal-branch">
                При передаче груза на&nbsp;терминал, доставка из&nbsp;вашего региона будет осуществляться в&nbsp;сроки, указанные в&nbsp;разделе
                <a href="/e-commerce/dokumenty/dokumenty-i-tarify" class="map-legend__tooltip-link" rel="noopener">Tарифы</a>
              </b-tooltip>
            </div>
          </div>
          <div class="map-legend__item" v-if="legend.expressReception">
            <img :src="hrefIconExpress" class="map-legend__icon" />
            <p class="map-legend__text">Экспресс-прием</p>
            <div class="map-legend__tooltip" ref="tooltipTerminalBranch">
              <b-button id="button-question__express"
                        class="icon-question d-none d-sm-inline-block"></b-button>
              <b-tooltip target="button-question__express" placement="bottom" boundary-padding="0" custom-class="tooltip_legend tooltip_legend-express-branch">
                При передаче посылки до&nbsp;17:00 отправление в&nbsp;этот&nbsp;же день, после 17:00&nbsp;&mdash; на&nbsp;следующий день
              </b-tooltip>
            </div>
          </div>
        </div>
      </div>
      <BranchFilter
        v-if="receptionQuery && showBranchFilter"
        :paramFilter="paramFilter"
        :classModifier="'map-filter_inline'"
        :labelHidden="false"
        :selectedCity="selectedCity"
        :show-tooltip="!newDesign"
        :show-filter-inline="newDesign"
        @change-filter="onChangeFilter"
      />

      <ODPPreviewModal
        class="map__container map__container_card"
        :hideODPPreview="hideODPPreview"
        :ODPPreview="ODPPreview"
        :buildRoute="buildRoute"
        :absolute-url="absoluteUrl"
        v-if="ODPPreview !== null"
      />
      <YmapsView
        style="width: 100%; height: 676px;"
        :showODPPreview="showODPPreview"
        :cityCode="cityCodeForce || code"
        ref="ymapsView"
        :receptionQuery="receptionQuery"
        :selectedCity="selectedCity"
        :signDepartment="signDepartment"
        :new-design="newDesign"
        @change-odp-collection="onChangeOdpCollection"
      />
    </div>
  </div>
</template>

<script>
import ODPPreviewModal from '../MapWidget/ODPPreviewModal.vue';
import YmapsView from './YmapsView.vue';
import FindOdpPanel from '../FindOdp/FindOdpPanel.vue';
import { getters as cityGetters } from '../../store/city.store';
import BranchFilter from '../BranchFilter/BranchFilter.vue';
import deviceInfo from '../../helpers/device';

// eslint-disable-next-line
const URL_PREFIX = urlPrefix || '/';

export default {
  name: 'EcommerceMapView',
  components: {
    YmapsView,
    ODPPreviewModal,
    FindOdpPanel,
    BranchFilter,
  },
  props: {
    absoluteUrl: {
      type: String,
      default: '',
    },
    showBranchFilter: {
      type: Boolean,
      default: true,
    },
    cityCodeForce: {
      type: String,
      default: '',
    },
    newDesign: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...cityGetters,
    ...deviceInfo,
    selectedCity() {
      return this.userSelectedCity || { Code: cityGetters.code(), Name: cityGetters.name() };
    },
    hrefIconTerminal() {
      return this.paramFilter.find((item) => item.name === 'terminalReception').img;
    },
    hrefIconExpress() {
      return this.paramFilter.find((item) => item.name === 'expressReception').img;
    },
    hrefIconBranch() {
      return this.paramFilter.find((item) => item.name === 'reception').img;
    },
  },
  data() {
    return {
      ODPPreview: null,
      receptionQuery: true,
      userSelectedCity: null,
      paramFilter: [
        {
          label: 'Прием в отделении',
          name: 'reception',
          img: this.newDesign ? `${URL_PREFIX}packages/boxberry/theme/frontend/boxberryvue/src/assets/branch-balloon.svg`:
            `${URL_PREFIX}packages/boxberry/theme/frontend/boxberryvue/src/assets/branch-balloon.png`,
          value: true,
        },
        {
          label: 'Прием на терминале',
          name: 'terminalReception',
          img: this.newDesign ? `${URL_PREFIX}packages/boxberry/theme/frontend/boxberryvue/src/assets/terminal-balloon.svg`:
            `${URL_PREFIX}packages/boxberry/theme/frontend/boxberryvue/src/assets/terminal-balloon.png`,
          value: true,
        },
        {
          label: 'Экспресс-прием',
          name: 'expressReception',
          img: this.newDesign ? `${URL_PREFIX}packages/boxberry/theme/frontend/boxberryvue/src/assets/express-balloon.svg`:
            `${URL_PREFIX}packages/boxberry/theme/frontend/boxberryvue/src/assets/express-balloon.png`,
          value: true,
        },
      ],
      signDepartment: {
        reception: true,
        terminalReception: true,
        expressReception: true,
      },
      legend: {
        expressReception: false,
        terminalReception: false,
        reception: false,
      },
    };
  },
  methods: {
    hideODPPreview() {
      this.ODPPreview = null;
    },
    buildRoute(e, odp) {
      e.preventDefault();
      this.$refs.ymapsView.getUserLocation(odp);
    },
    showODPPreview(odp) {
      this.ODPPreview = odp.data;
      this.$bvModal.show('ODPPreviewModal');
    },
    onCitySelect(city) {
      this.userSelectedCity = city;
    },
    onChangeFilter(value) {
      if (value.length) {
        value.forEach((item) => {
          this.signDepartment[item.name] = item.value;
        });
      }
    },
    /**
    * @param {Array} collection
    * switch legend
    */
    onChangeOdpCollection(collection) {
      this.legend = {
        expressReception: false,
        terminalReception: false,
        reception: false,
      };
      if (collection.length) {
        collection.forEach((item) => {
          if (item.expressReception && !this.legend.expressReception) {
            this.legend.expressReception = true;
          }
          if (item.terminalReception && !this.legend.terminalReception) {
            this.legend.terminalReception = true;
          }
          if (item.reception && !item.expressReception && !item.terminalReception && !this.legend.reception) {
            this.legend.reception = true;
          }
        });
      }
    },
  },
  watch: {
    selectedCity(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.hideODPPreview();
      }
    },
    receptionQuery(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.hideODPPreview();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./EcommerceMap.scss";
</style>
<style lang="scss">
.ecommerce-map {
  .map-filter__icon {
    width: 24px;
    height: 24px;
  }
  .map-filter__text {
    font-size: 14px;
    font-weight: 600;
    line-height: 19.6px;
    color: #50616F;
    p {
      border: none;
    }
  }
  .field-checkbox_switch .field-checkbox__input[type="checkbox"]:checked + .field-checkbox__label::before {
    background: url("https://storage.yandexcloud.net/boxberrysite-public/e_commerce/icon-checkbox-active.svg");
  }
  .field-checkbox_switch .field-checkbox__label {
    padding-right: 42px;
    @media(max-width: 767px) {
      padding-left: 0;
    }
  }
  .field-checkbox_switch .field-checkbox__label::after {
    content: none;
  }
  .field-checkbox_switch .field-checkbox__label::before {
    top: calc(50% - 2px);
    right: 0;
    transform: translate(0, -50%);
    width: 36px;
    height: 24px;
    background: url("https://storage.yandexcloud.net/boxberrysite-public/e_commerce/icon-checkbox.svg") center no-repeat;
    transition: none !important;
    box-shadow: none !important;
    border: none !important;
    @media(max-width: 767px) {
      position: static;
      top: auto;;
      right: auto;
      transform: none;
      order: 2;
      margin-left: 16px;
    }
  }
  .map-filter.map-filter_inline {
    margin-left: auto;
    margin-right: auto;
  }
  .map-filter__item:before {
    content: none;
  }
  .map-filter_inline .map-filter__item .field-checkbox_switch {
     margin: 0 33px;
  }
  .map-filter_inline .map-filter__item:first-child .field-checkbox_switch {
    margin-left: 0;
  }
  .map-filter_inline .map-filter__item:last-of-type .field-checkbox_switch {
    margin-right: 0;

  }
  .map__title {
    padding-bottom: 57px;
    font-size: 32px;
    font-weight: 700;
    line-height: 38.4px;
    color: #333333;
    @media(max-width: 767px) {
      display: flex;
      flex-direction: column;
      padding-bottom: 29px;
      font-size: 20px;
      line-height: 26px;
    }
  }
  .map-tab {
    padding-left: 5px;
    padding-right: 5px;
    flex-basis: 50%;
    flex-grow: 1;
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 19.07px;
    color: #9FB3C3;
    text-align: center;
    &_active {
      color:#ED1651;
    }
    @media(max-width: 767px) {
      padding-bottom: 8px;
      font-size: 12px;
      line-height: 16.34px;
    }
  }
  .map-filter__icon {
    margin-right: 3px;
    margin-top: -2px;
    width: 24px;
    height: 24px;
  }
  .city-name {
    margin-right: 47px;
    @media(max-width: 767px) {
      margin-right: 28px;
      margin-top: 4px;
    }
  }
  .city-name__arrow {
    right: -47px;
    @media(max-width: 767px) {
      width: 22px;
      height: 10px;
      right: -28px;
    }
  }
  #pointsMapEcommerce {
    box-shadow: 2.87px 2.87px 7.19px 0 rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    @media(max-width: 767px) {
      box-shadow: none;
    }
  }
  .map-tabs {
    @media(max-width: 767px) {
      margin-bottom: 8px;
    }
  }
  .map-tab.map-tab_active::after {
    @media(max-width: 767px) {
      left: 0;
    }
  }
}
</style>
